export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0058.b0398343.webp";